import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertRoute from "../../../components/routeComponent/insert_route";
import { translate } from "react-i18next";

class AddRouteMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/route");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/route" />
        <div className="m-2">
          <InsertRoute
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default translate("route")(AddRouteMaster);
